/**
 * SFN i18n — 한국어 (ko-KR). Overlays EN base with professional translations
 * for every REQUIRED_I18N_KEYS entry.
 */
import type { Dict } from "./types";
import { en } from "./en";

export const ko: Dict = {
  ...en,

  // Navigation
  "nav.home": "홈",
  "nav.about": "소개",
  "nav.contact": "문의",
  "nav.ecosystem": "생태계",
  "nav.tokens": "토큰",
  "nav.protection": "보호",
  "nav.secure": "확보",
  "nav.faq": "자주 묻는 질문",
  "nav.connectWallet": "지갑 연결",
  "nav.language": "언어",

  // Hero
  "hero.eyebrow": "솔라나에서 검증된 $1 인플레이션 보호",
  "hero.stat1": "확보된 식사",
  "hero.stat2": "실물 자산 담보",
  "hero.stat3": "평균 정산 속도",

  // Bento
  "bento.title": "Sustainable Food & Eco Network (SFN): 작동 방식",
  "bento.sub": "토크노믹스, 유틸리티, 회복탄력성 — 테이스팅 메뉴처럼 구성했습니다.",
  "bento.card1.title": "비전과 네트워크 (SFN)",
  "bento.card1.text":
    "SFN은 인증 파트너 주방, 지역 농부, 후원자로 구성된 개방형 분산 네트워크입니다. 커뮤니티 자금과 태양광 기반 운영을 결합해 식료품 생산 비용을 압도적으로 낮고 안정적으로 유지합니다.",
  "bento.card2.title": "분산형 지역 소싱 허브",
  "bento.card2.text":
    "우리의 앵커 운영은 30 THB 식사 프레임워크를 매일 검증하는 실사용 테스트베드입니다. 이 허브에서 대량 식재료 조달, 태양광 주방 인프라, 모든 파트너 지점이 승계하는 운영 표준을 총괄합니다.",
  "bento.card3.title": "확장 가능한 글로벌 임팩트",
  "bento.card3.text":
    "우리는 한 주방에서 멈추지 않습니다. SFN은 성장을 전제로 설계되었습니다. 국제 후원자는 디지털로 식사를 후원할 수 있고, 지역 소규모 식당은 네트워크에 합류해 보조 식재료와 태양광 에너지를 활용할 수 있습니다.",

  // Pilot / Sandbox
  "pilot.eyebrow": "라이브 파일럿 개념 증명: Thailand Sandbox",
  "pilot.title": "태국: 1단계 파일럿 시장 (샌드박스 존)",
  "pilot.body":
    "고효율 지역 시장에서 출범함으로써 MEAL4/MEAL2 토크노믹스와 실제 공급망을 최대의 운영 통제 아래 스트레스 테스트합니다. 모든 주방·식재료 흐름·정산 경로는 통제된 환경에서 검증된 뒤 SFN이 국제 확장을 실행합니다.",
  "pilot.benchmark.label": "$1 글로벌 벤치마크",
  "pilot.benchmark.value": "$1",
  "pilot.benchmark.desc": "식사 가격을 30 THB（$1） 이하로 앵커링하며, 지역화된 Web3 메커니즘으로 글로벌 확장성을 입증합니다.",
  "pilot.phase1": "1단계: 지역 파일럿 ($1 목표)",
  "pilot.phase2": "2단계: 글로벌 확장",
  "pilot.phase.arrow": "로드맵 경로",
  "pilot.stat1.label": "파일럿 시장",
  "pilot.stat1.value": "태국 · 카오요이",
  "pilot.stat2.label": "식사 앵커",
  "pilot.stat2.value": "$1",
  "pilot.stat3.label": "다음 단계",
  "pilot.stat3.value": "글로벌 확산",

  // About
  "about.eyebrow": "창업자와 미션",
  "about.titleA": "그 이면의",
  "about.titleB": "Sustainable Food & Eco Network",
  "about.body":
    "SFN은 독일식 경영학과 태국 현장 요식업을 잇는 창업 팀이 설립했습니다. 세계적 인플레이션이 지역 사회를 직격하는 현장을 목격한 뒤, 우리는 투기가 아닌 인간의 기본적 안정을 위해 블록체인 기술을 활용하기로 결심했습니다. 태국 페차부리의 파일럿 주방은 투명하고 태양광으로 구동되는 분산형 식량 안보의 미래를 위한 운영 청사진입니다.",

  // Contact
  "contact.eyebrow": "파트너십 문의",
  "contact.titleA": "네트워크에",
  "contact.titleB": "참여하세요",
  "contact.body":
    "MEAL 토큰을 수용하려는 지역 주방, 직접 공급하려는 농부, 궁금한 국제 후원자 등 언제든지 연락 주세요.",
  "contact.name": "이름",
  "contact.namePh": "성함을 입력하세요",
  "contact.email": "이메일",
  "contact.emailPh": "you@example.com",
  "contact.subject": "제목",
  "contact.subjectPh": "파트너십, 공급, 지원…",
  "contact.message": "메시지",
  "contact.messagePh": "프로젝트나 질문을 알려주세요…",
  "contact.sent": "메시지를 안전하게 전송했습니다",
  "contact.successBody":
    "암호화된 엔드포인트로 안전하게 전달되었습니다. 담당자가 48시간 이내에 회신드립니다.",
  "contact.errorTitle": "전송 실패",
  "contact.errorBody": "메시지를 전달하지 못했습니다. 연결 상태를 확인 후 다시 시도해 주세요.",
  "contact.dismissOk": "다시 보내기",
  "contact.dismissError": "재시도",
  "contact.responseNote": "보통 48시간 이내에 회신드립니다.",
  "contact.send": "메시지 보내기",

  // Dual-token
  "dual.eyebrow": "듀얼 토큰 아키텍처",
  "dual.title": "듀얼 토큰 시스템: 보호와 실용성의 결합",
  "dual.sub":
    "MEAL4는 가치를 옮기고, MEAL2는 가치를 정지시킵니다. 둘이 만나야 식량 안보가 실제 소비 가능한 형태가 됩니다.",
  "dual.meal4.t": "MEAL4 – 인플레이션 실드",
  "dual.meal4.d":
    "총량이 100만 토큰으로 엄격히 제한되며 추가 발행이 영구적으로 불가능합니다. MEAL4는 실물 자산 준비와 전략적 대량 구매력에 뒷받침된 디지털 계약으로, 식료품 생산 비용을 근본에서 동결하고 시장 가격 상승에 대한 디플레이션 헤지를 형성합니다.",
  "dual.meal2.t": "MEAL2 – 데일리 유틸리티",
  "dual.meal2.d":
    "매장 운영, 리워드, 커뮤니티 지원을 매끄럽게 하는 실용적인 일상 토큰입니다. 즉시 모바일 결제, 지역 손님 로열티 할인, 전 세계 후원자의 투명한 디지털 식사 후원을 가능하게 하며 생태계를 구동합니다.",

  // Protection
  "protection.eyebrow": "변경 불가한 보안 · 온체인",
  "protection.title": "코드에 각인된 철회 불가한 신뢰",
  "protection.sub":
    "스마트 컨트랙트에 엄격한 보안 파라미터를 하드코딩해 인플레이션과 무단 변경으로부터 커뮤니티를 보호합니다.",
  "protection.f1.title": "100% 프리즈 방지 자산",
  "protection.f1.text":
    "두 토큰 모두 ‘Freeze Authority’가 영구히 폐기되었습니다. 어떤 중앙 권력·기관·개발자도 지갑을 동결하거나 MEAL 사용을 막을 수 없습니다.",
  "protection.f2.title": "하드코딩된 공급 상한 (MEAL4)",
  "protection.f2.text":
    "MEAL4의 ‘Mint Authority’는 되돌릴 수 없이 파기되었습니다. 100만 개를 초과하는 발행은 수학적으로 불가능하며 식량 안보 헤지는 희석에서 영구히 보호됩니다.",
  "protection.f3.title": "유연한 유틸리티 확장 (MEAL2)",
  "protection.f3.text":
    "SFN에 합류하는 새 파트너 주방과 매끄럽게 확장하기 위해 MEAL2에만 의도적으로 발행 기능을 남겨 두어, 지역 경제에 충분한 거래 연료를 공급합니다.",

  // Swap
  "swap.eyebrow": "토큰 세일",
  "swap.title": "식사를 확보하세요",
  "swap.sub":
    "MEAL4로 바로 스왑하세요. 각 토큰은 파트너 주방에서 오늘·내일·어떤 위기 이후에도 한 끼를 보장합니다.",
  "swap.connectWallet": "스왑하려면 지갑 연결",
  "swap.meal4.milestoneLabel":
    "현재 마일스톤: 1단계 목표 — Thailand Sandbox 중앙 주방 인프라 및 초기 익스프레스 확장",
  "swap.meal4.milestoneProgress": "모금 {raised} / {goal} USDC",
  "swap.meal4.percent": "{pct}% 달성",
  "swap.meal4.treasuryLabel": "프로젝트 트레저리 지갑",
  "swap.meal4.treasuryNote":
    "출자금은 SFN 프로젝트 트레저리로 직접 라우팅됩니다 — DEX나 공개시장 경유가 없습니다.",
  "swap.meal4.tooltip":
    "토큰 분배는 실물 재고로 직접 뒷받침되며, 가격 안정을 위해 마일스톤 단계별 자금 조달로 관리됩니다.",
  "swap.meal4.tooltipAria": "마일스톤 자금 조달 방식",
  "swap.meal2.rateLabel": "고정 환율 · 1 USDC = 1 MEAL2",
  "swap.meal2.payWith": "결제 수단",
  "swap.meal2.solRoute": "자동 라우팅: SOL → USD(Jupiter) → MEAL2, 단위당 $1",
  "swap.meal2.priceFallback": "참고 가격 (피드 오프라인)",
  "swap.phantomApproving": "Phantom 승인을 기다리는 중…",

  // Trust
  "trust.eyebrow": "투명성과 신뢰",
  "trust.title": "만질 수 있는 실물이 뒷받침합니다.",
  "trust.body":
    "생태계는 실물 자산으로 정박되어 있습니다: 태국의 파트너 레스토랑 ‘SFN 파일럿 키친’, 지원 부동산, 매일 실제 접시를 내는 운영 주방. 지역과 운영은 공개하되, 팀과 손님의 안전을 위해 정확한 주소는 비공개합니다.",

  // FAQ
  "faq.eyebrow": "자주 묻는 질문",
  "faq.title": "자주 묻는 질문",
  "faq.sub":
    "Sustainable Food & Eco Network (SFN)와 식사 안정화 생태계에 대해 알아야 할 모든 것.",
  "faq.q1": "인플레이션 속에서 어떻게 $1짜리 건강한 고품질 식사를 보장하나요?",
  "faq.a1":
    "세 가지 축을 결합합니다: 지역 농부에게서 직접 이루어지는 전략적 대량 구매, 태양광 인프라를 통한 매장 운영비 절감, 그리고 MEAL4 인플레이션 실드를 통한 커뮤니티 지원. 이를 통해 주방의 기본 가격이 시장 인플레이션과 완전히 분리됩니다.",
  "faq.q2": "토큰이 확대되면 매장 하나가 수요를 감당할 수 있나요?",
  "faq.a2":
    "그럴 필요가 없습니다. ‘SFN 파일럿 키친’는 실사용 개념 증명이며, 상위 아키텍처는 SFN 자체입니다. 수요가 커지면 독립 지역 주방과 소규모 식당이 네트워크에 합류해 보조 식재료와 인프라를 사용해 30 THB 약속을 전 세계로 확장할 수 있습니다.",
  "faq.q3": "태국에 살지 않는 국제 후원자는 어떻게 참여하나요?",
  "faq.a3":
    "국제 후원자는 MEAL2 토큰을 구매해 디지털 ‘식사 후원’을 시작할 수 있습니다. 후원된 토큰은 투명하게 지역 사회 지원 프로그램에 배분되어 어르신, 저소득 가정, 취약 계층이 인증된 SFN 주방에서 무료 또는 30 THB에 식사할 수 있게 합니다.",
  "faq.q4": "MEAL4는 일반 암호화폐와 어떻게 다른가요?",
  "faq.a4":
    "MEAL4는 투기 토큰이 아니라 실물 식량 비축과 지속 가능한 요식업 인프라 확장을 뒷받침하는 실용 계약입니다. 발행 권한이 영구 폐기되었기에 식량 안보를 위해 수학적으로 상한이 정해진 가치 저장 수단으로 작동합니다.",

  // Roadmap
  "roadmap.eyebrow": "실행 · 궤적",
  "roadmap.title": "공장 현장에서 글로벌 프로토콜까지",
  "roadmap.sub":
    "현실 반복 6단계의 여정. 모든 마일스톤은 슬라이드가 아니라 운영의 현실에 뿌리내리고 있습니다.",
  "roadmap.card1.title": "공장 근로자 식량 공급",
  "roadmap.card1.desc":
    "1식당 45 THB를 넘긴 식품 인플레이션을 목격하고, 공장 근로자와 저소득층이 건강한 영양에서 점점 밀려나는 현실을 확인.",
  "roadmap.card2.title": "$1 프레임워크 구상",
  "roadmap.card2.desc":
    "안정적인 30 THB 마진을 목표로 하는 경제 프레임워크를 설계 — 영구적으로 합리적이고 고품질인 식사의 토대.",
  "roadmap.card3.title": "공급망 소싱 테스트",
  "roadmap.card3.desc":
    "농부 직결 소싱 파일럿을 진행하며 단일 매장 모델의 구조적 한계를 파악하고 분산형 지역 소싱 허브의 필요성을 정의.",
  "roadmap.card4.title": "다지점 확장과 태양광의 뿌리",
  "roadmap.card4.desc":
    "여러 지점으로 확장하며 일관된 에너지 오버헤드를 발견해 태양광 인프라가 놓쳤던 비용 안정화 계층임을 검증.",
  "roadmap.card5.title": "운영 검증과 $1 파일럿",
  "roadmap.card5.desc":
    "월 전반에 걸쳐 판매가 절대적으로 안정 — 월 중반 하락 없음 — 30 THB 모델이 규모 확장 시에도 운영적으로 지속 가능함을 증명.",
  "roadmap.card6.title": "SFN 토큰화와 SolarPando 스프린트",
  "roadmap.card6.desc":
    "SFN이 Solana에서 공식 출범: MEAL4·MEAL2 토큰 제네시스, 불변성 검증, SolarPando 인프라 스프린트가 동시에 가동.",

  // Docs
  "docs.eyebrow": "지식 베이스",
  "docs.title": "백서 및 법적 문서",
  "docs.sub": "공식 SFN 문서와 감사 보고서를 다운로드하세요.",
  "credits.line": "컨셉 및 프레임워크 제작: Boy Khomkrit — 최초 공개: 2021년 7월 4일",
  "credits.date": "최초 작성일: 2021년 7월 4일 (04.07.2021)",
  "credits.version": "백서 v1.0 — 최초 공개: 2021년 7월 4일",
  "docs.btn1": "SFN 생태계 백서 (EN)",
  "docs.btn2": "이그제큐티브 토크노믹스 요약 (DE)",
  "docs.btn3": "태국 요식업 법적 프레임워크",
  "docs.btn4": "암호 보안 감사 보고서",

  // Verify
  "verify.meal4.title": "MEAL4 — 인플레이션 실드 검증",
  "verify.meal4.sub": "변경 불가한 자산 파라미터",
  "verify.meal4.cta": "Solana Explorer에서 MEAL4 보기",
  "verify.meal2.title": "MEAL2 — 데일리 유틸리티 검증",
  "verify.meal2.sub": "유연한 유틸리티 파라미터",
  "verify.meal2.cta": "Solana Explorer에서 MEAL2 보기",
  "verify.item.meal4Supply.label": "MEAL4 공급 상한 검증",
  "verify.item.meal4Supply.statusPassed": "통과 - 상한 1,000,000",
  "verify.item.meal4Supply.statusLive": "통과 - 온체인 공급량: ",
  "verify.item.meal4Mint.label": "MEAL4 민팅 권한",
  "verify.item.meal4Mint.statusPassed": "통과 - 파기됨 (100만 하드캡)",
  "verify.item.meal4Mint.statusActive": "활성 - 민팅 권한 존재",
  "verify.item.meal4Freeze.label": "MEAL4 프리즈 권한",
  "verify.item.meal4Freeze.statusPassed": "통과 - 폐기됨 (중앙 통제 없음)",
  "verify.item.meal4Freeze.statusActive": "활성 - 프리즈 권한 존재",
  "verify.item.meal2Freeze.label": "MEAL2 프리즈 권한",
  "verify.item.meal2Freeze.statusPassed": "통과 - 폐기됨 (유동성 해제)",
  "verify.item.meal2Freeze.statusActive": "활성 - 프리즈 권한 존재",
  "verify.item.meal2Mint.label": "MEAL2 민팅 권한",
  "verify.item.meal2Mint.statusRevoked": "폐기됨 - 공급 동결",
  "verify.item.meal2Mint.statusActive": "활성 - SFN 성장 프로토콜 관리",
  "verify.item.meal2Supply.label": "MEAL2 유통 공급량",
  "verify.item.meal2Supply.statusLive": "라이브 - ",
  "verify.badge.connecting": "연결 중",
  "verify.badge.cached": "캐시됨",
  "verify.badge.verified": "검증됨",
  "verify.networkBusy": "네트워크 혼잡, 연결 재시도 중… (시도 ",

  // Transparency
  "transparency.jsonImmutable": "// 불변. 변경 불가.",
  "transparency.jsonCeiling": "// 하드코딩된 상한.",

  // Connection
  "connection.eyebrow": "// 연결",
  "connection.step1.title": "대량 구매",
  "connection.step1.text":
    "MEAL4 준비금이 지역 농부로부터의 대규모 직접 소싱을 자금 조달해 식재료 비용을 시장 인플레이션 아래로 고정.",
  "connection.step2.title": "태양광 인프라",
  "connection.step2.text":
    "오프그리드 태양광 어레이가 파트너 주방에 24시간 전력을 공급해 각 접시의 원가에서 에너지 변동을 제거.",
  "connection.step3.title": "교환 가능한 식사",
  "connection.step3.text":
    "손님은 스캔 후 MEAL2로 결제하고 USD 1 미만으로 따뜻하고 영양가 있는 한 접시를 받습니다 — 실제 테이블 위에서 완결되는 디지털 계약.",

  // Barometer
  "barometer.eyebrow": "라이브 · 온체인 · 검증됨",
  "barometer.title.a": "실세계",
  "barometer.title.b": "재고 바로미터",
  "barometer.sub":
    "모든 식사를 뒷받침하는 실물 준비를 투명하게 들여다봅니다. 수치는 파일럿 주방에서 갱신됩니다 — 추측이 아닌 재고.",
  "barometer.rice": "쌀 비축",
  "barometer.oil": "식물성 기름",
  "barometer.solar": "태양광 전력 상태",

  // Footer
  "footer.tag":
    "SFN(Sustainable Food & Eco Network)와 MealToken24는 블록체인 기술을 인플레이션 및 글로벌 식량 불안정에 맞선 무기로 삼는 데 헌신합니다. 실제 주방에서 구동되며, 실제 사람을 위해 설계되었습니다.",
  "footer.disclaimer":
    "고지: MEAL2와 MEAL4는 Sustainable Food & Eco Network 요식업 생태계 내 실사용을 위한 유틸리티 및 자산 담보 커뮤니티 토큰이며, 금융 투자나 전통적 증권을 구성하지 않습니다.",
  "footer.about": "소개",
  "footer.contact": "문의",
  "footer.legal": "법적 고지",
  "footer.rights": "All rights reserved.",

  // Milestones
  "milestones.eyebrow": "즉시 로드맵: 블록체인과 물리적 인프라의 연결",
  "milestones.p1.title": "SFN 중앙 주방 허브 (카오요이)",
  "milestones.p1.desc":
    "기관 자본으로 자금이 조달되는 예정된 자동화 중앙 처리 시설이 대량 식재료 조달, 태양광 냉장, 무폐기 식사 준비를 담당합니다. 이는 중간 유통 비용을 제거하고 배송 이전에 가격 안정성을 보장합니다.",
  "milestones.p1.target": "100% 태양광 기반 공급망 상호 연결.",
  "milestones.p2.title": "스마트 익스프레스 지점의 초확장",
  "milestones.p2.desc":
    "입증된 요식업 프레임워크를 앵커 매장에서 주요 고교통량 회랑을 따라 있는 고효율 익스프레스 식당의 지역 네트워크로 확장합니다. 각 지점은 보조된 제로 코스트 에너지 그리드에서 운영됩니다.",
  "milestones.p2.target": "다지점 지역 샌드박스 롤아웃.",

  // VillagePando additions (Phase A)
  "vp.swap.pegged.badge": "1:1 USDC 담보 바우처",
  "vp.swap.pegged.tooltip":
    "각 VillagePando 바우처는 1 USDC의 준비금으로 1:1 담보되며 언제든 액면가로 상환할 수 있습니다.",
  "vp.swap.tax.eyebrow": "5% 태양광 세금",
  "vp.swap.tax.title": "이 5%는 어디로 가나요?",
  "vp.swap.tax.intro":
    "모든 거래에서 자동 공제되는 5%는 100% 검증 가능한 공공 인프라로 라우팅되며, 프로젝트 이익으로 남지 않습니다.",
  "vp.swap.tax.total": "세금 합계",
  "vp.swap.tax.perTx": "거래당",
  "vp.swap.tax.hardware.label": "태양광 하드웨어 기금",
  "vp.swap.tax.hardware.detail":
    "파트너 주방과 마을 노드를 위한 오프그리드 태양광 패널, 인버터, 배터리 스토리지 조달.",
  "vp.swap.tax.reforestation.label": "재조림 및 토지",
  "vp.swap.tax.reforestation.detail":
    "등록된 부지에서 토종 수목 식재와 토양 재생을 지원하며 온체인 증거 기록.",
  "vp.swap.tax.ops.label": "운영 및 규정 준수",
  "vp.swap.tax.ops.detail":
    "하드웨어 유지, 설치 인력 교육, 다관할권 규정 준수 비용을 부담.",
  "vp.nexus.trio.eyebrow": "// 판도 트리오 · 순환 흐름",
  "vp.nexus.trio.caption":
    "땅이 물을 기르고, 물이 에너지를 기르고, 에너지가 식사를 되사고, 식사가 마을을 지탱합니다.",
  "vp.nexus.trio.step1": "땅 → 물",
  "vp.nexus.trio.step2": "물 → 에너지",
  "vp.nexus.trio.step3": "에너지 → 식사 바이백",
  "vp.nexus.trio.step4": "식사 → 마을",
  "nav.tokenomics": "토크노믹스",
  "nav.roadmap": "로드맵",
  "nav.vision": "비전",
  "nav.whitepaper": "백서",

  // Treasury transparency & purchase receipt
  "treasury.eyebrow": "정산 투명성",
  "treasury.title": "모든 MEAL2·MEAL4 구매는 단일 트레저리로 정산됩니다",
  "treasury.desc": "구매는 DEX나 중간 지갑을 거치지 않습니다. 전체 수신 주소는 마우스를 올리면 표시되며, 버튼이 활성화되기 전에 온체인으로 검증됩니다.",
  "treasury.label": "프로젝트 트레저리",
  "treasury.network": "네트워크",
  "treasury.copy": "주소 복사",
  "treasury.copied": "복사됨",
  "treasury.explorer": "익스플로러에서 보기",
  "treasury.status.checking": "수신 주소 검증 중",
  "treasury.status.verified": "수신 주소 검증 완료",
  "treasury.status.degraded": "주소 유효 · 네트워크 혼잡",
  "treasury.status.invalid": "수신 주소 미검증 — 구매 비활성화",
  "receipt.eyebrow": "거래 정산 완료",
  "receipt.title": "구매 확인",
  "receipt.desc": "기여금이 SFN 프로젝트 트레저리로 전송되었습니다. 아래 서명을 정산 증빙으로 보관하세요.",
  "receipt.amount": "결제 금액",
  "receipt.received": "수령 금액",
  "receipt.destination": "트레저리 수신 주소",
  "receipt.network": "네트워크",
  "receipt.hash": "트랜잭션 서명",
  "receipt.viewExplorer": "익스플로러에서 거래 보기",
  "receipt.close": "확인 닫기",
  "receipt.copyHash": "해시 복사",
  "receipt.hashCopied": "해시 복사됨",
  "receipt.download": "JSON 다운로드",
  "rpc.checking": "네트워크 대상 검증 중…",
  "rpc.degraded": "네트워크 혼잡 — 주소는 유효하며 온체인 확인을 재시도합니다",
  "rpc.invalid": "대상 미검증 — 구매가 비활성화되었습니다",

  // Analytics consent
  "consent.title": "분석 동의",
  "consent.desc": "이 페이지 개선을 위해 익명·쿠키 없는 제품 분석(IP·핑거프린트 없음)을 사용합니다. 동의하기 전에는 아무것도 전송되지 않습니다.",
  "consent.accept": "동의",
  "consent.decline": "거부",
  "meal2.tab.web3": "디지털 스왑 (Web3)",
  "hero.title": "음식 가격을 동결합니다: 건강한 한 끼를 $1로, 영원히.",
  "hero.sub": "단순한 유틸리티. 실제 인프라. Meal2와 Meal4가 구동합니다.",
  "hero.badge": "세계 최초의 듀얼 토큰 식량 인프라 — $1 한 끼로 식품 인플레이션을 헤지합니다.",
  "hero.cta": "Meal2 구매 ($1 한 끼)",
  "hero.ghost": "Meal4 받기 (거버넌스)",
  "keep.title": "$1 식사를 유지하는 방법",
  "keep.sub": "세 가지 실물 자산이 비용 압력을 흡수해 한 접시 가격을 고정합니다.",
  "keep.solar.title": "태양광 에너지",
  "keep.solar.text": "오프그리드 태양광이 모든 주방에 전력을 공급해 전기 요금을 식사 원가에서 제거합니다.",
  "keep.agri.title": "농업",
  "keep.agri.text": "농가 직거래와 재조림으로 중간 유통 없이 식재료 원가를 고정합니다.",
  "keep.water.title": "깨끗한 물",
  "keep.water.text": "여과 저수조가 건기에도 일일 생산을 보장하며 변동비가 없습니다.",
  "brand.tagline": "$1 푸드 엔진",
  "nav.product": "제품",
  "nav.pilot": "파일럿 키친",
  "trustpilot.eyebrow": "개념 증명 · 파일럿 지역",
  "trustpilot.title": "태국에서 검증 — 글로벌 확장.",
  "trustpilot.desc": "앵커 키친과 커뮤니티 허브가 이미 운영 중입니다. 여기 소개된 모든 메커니즘은 실제 식사, 실제 생산자, 실제 지역에서 검증한 뒤 확장합니다.",
  "trustpilot.b1": "앵커 키친 매일 운영",
  "trustpilot.b2": "지역 생산자 네트워크",
  "trustpilot.b3": "태양광 커뮤니티 허브",
  "trustpilot.b4": "온체인 정산 가동 중",
  "swap.quote.title": "실시간 경로 견적",
  "swap.quote.slippage": "최대 슬리피지",
  "swap.quote.expiry": "견적 유효 시간",
  "swap.quote.minReceive": "최소 수령량",
  "swap.quote.usdValue": "예상 가치",
  "swap.quote.expiresIn": "{s}초 후 갱신",
  "swap.quote.expired": "견적 만료됨 — 새로고침하세요",
  "swap.quote.refresh": "견적 새로고침",
  "swap.quote.expiredError": "견적이 만료되었습니다. 환율을 새로고침한 후 다시 시도하세요.",
  "swap.quote.slippageError": "SOL 환율이 슬리피지 한도를 초과했습니다. 서명은 진행되지 않았습니다.",
  "verify.badge": "구매 증명",
  "verify.title": "영수증 검증",
  "verify.intro": "Solana 트랜잭션 서명을 붙여넣으면 네트워크와 SFN 원장에서 구매를 직접 확인합니다. 검증은 서버에서 실행되며 지갑 연결이 필요 없습니다.",
  "verify.modalIntro": "서버에서 검증한 온체인 상태와 일치하는 원장 기록입니다.",
  "verify.label": "트랜잭션 서명",
  "verify.placeholder": "Solana 트랜잭션 서명을 붙여넣으세요",
  "verify.submit": "영수증 검증",
  "verify.busy": "검증 중…",
  "verify.close": "영수증 검증 닫기",
  "verify.verified": "온체인 검증 완료",
  "verify.unreachable": "네트워크에 연결할 수 없습니다 — 잠시 후 재시도",
  "verify.notConfirmed": "확인되지 않음",
  "verify.invalid": "올바른 Solana 서명이 아닙니다.",
  "verify.rateLimited": "조회가 너무 많습니다. 1분 후 다시 시도하세요.",
  "verify.replay": "이 세션에서 이미 확인한 서명입니다.",
  "verify.error": "검증 서비스가 혼잡합니다. 잠시 후 다시 시도하세요.",
  "verify.receiptId": "영수증 ID",
  "verify.signature": "서명",
  "verify.ledgerEntry": "원장 기록",
  "verify.purchase": "구매",
  "verify.value": "가치",
  "verify.wallet": "지갑",
  "verify.checks": "정산 검사",
  "verify.noLedger": "이 서명과 일치하는 SFN 원장 기록이 아직 없습니다. 방금 결제했다면 몇 초 후 다시 확인하세요.",
  "verify.explorer": "Solscan에서 보기",
  "admin.csv.export": "CSV 다운로드",
  "admin.csv.exportLabel": "판매 원장을 CSV 파일로 다운로드",
  "dexRoadmap.title": "유동성 및 인덱싱 로드맵",
  "dexRoadmap.phase1": "프리세일 및 유틸리티 출시",
  "dexRoadmap.phase2": "Jupiter 스트릭트 리스트 및 Raydium 유동성 풀",
  "dexRoadmap.phase3": "CoinGecko 및 CoinMarketCap 토큰 인덱싱",
  "dexRoadmap.active": "진행 중",
  "dexRoadmap.status.active": "진행 중",
  "dexRoadmap.status.next": "다음 단계",
  "dexRoadmap.status.planned": "예정",
  "dexRoadmap.statusLive": "로드맵 단계 상태가 실시간으로 표시됩니다.",
  "dexRoadmap.statusFallback": "실시간 상태를 불러올 수 없어 공개된 계획을 표시합니다.",
  "dexRoadmap.visit": "{name}을(를) 새 탭에서 열기",
  "swap.quote.refreshing": "환율 새로고침 중…",
};
